import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import type { CreateVacancyRequest, Vacancy } from '../types';
import { MutationKey } from '@shared/config';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useCreateVacancy = (): UseMutationResult<
  Vacancy,
  AxiosError<TFormErrorResponse>,
  CreateVacancyRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.CREATE_VACANCY],
    mutationFn: (vacancy: CreateVacancyRequest) =>
      vacancyApi.createVacancy(vacancy),
  });
};
